import { flat, unique } from 'radash';
import useSWRImmutable from 'swr/immutable';

import { publicConfig } from '@public-config';

import { ApiService } from 'services/ApiService';

import { IndustryCategory, IndustrySubcategory } from '@/payload-types';

const RESOURCE_URL = `${publicConfig.urls.api}/industryCategories/categories-with-profile-counts`;

type MakeSlugRequired<T> = Omit<T, 'slug'> & { slug: string };

export type IndustryCategoriesWithProfileCounts = (Omit<MakeSlugRequired<IndustryCategory>, 'subcategories'> & {
    subcategories: MakeSlugRequired<IndustrySubcategory & { profileCount: number }>[];
})[];

export const useIndustryCategories = () => {
    const swr = useSWRImmutable(
        RESOURCE_URL,
        async () => await ApiService.get<IndustryCategoriesWithProfileCounts>(RESOURCE_URL),
    );

    // TODO temp solution
    const filteredData = swr.data?.filter((category) => category.slug !== 'manufacturers');

    return {
        ...swr,
        industryCategories: filteredData ?? [],
        subCategories: unique(
            flat(swr.data?.map((category) => category.subcategories) ?? []),
            (subcategory) => subcategory.id,
        ),
    };
};
